//Aqui solo constantes propias del app
export const appConstantes = {
  SIN_DATOS: "No existen registros",
};

export const nemonicoIdentificacion = {
  CEDULA: "C",
  PASAPORTE: "P",
};

export const nemonicoProceso = {
  SOLICITUD_RESERVA_DENOM: "SOLICITUD_RESERVA_DENOM",
  CAJAS: "PRORESCAJAS",
  SICCA_SOL_RESERV: "SICCA_SOL_RESERV",
};

export const limitSize = {
  TEXT_AREA: 500,
  TEXT_INPUT: 200,
  TEXT_INPUT_NUMBER: 10,
  TEXT_INPUT_DEFECTO: 200,
  TEXT_INPUT_NOMBRE: 250,
  TEXT_INPUT_NOMBRE: 250,
  TEXT_INPUT_1000: 1000,
  TEXT_INPUT_300: 300,
};

export const nemonicoGruposCatalogos = {
  TIPO_CAJA: "TIPO_CAJA",
  TIPO_CELULAR: "CELULAR",
};

export const nemonicoSistema = {
  SICCA: "SISTSICCA",
  CARGO_REPRESENTANTE_LEGAL: "CARG_REPRESENTANTE_LEGAL",
};

export const nemonicoFlujo = {
  FLUARESENT: "FLUARESENT",
};

export const nemonicoTipoSolicitud = {
  CONSTITUCION: "CONSTITUCION",
  ADECUACION: "ADECUACION",
};

export const nemonicoOrganoControl = {
  GOB_DIRECTIVO: "GOB_DIRECTIVO",
  GOB_CONTROL: "GOB_CONTROL",
  CARGO_DIRECTIVO: "TCARG_DIRECTIVO",
};

export const nemonicoEstadoOpciones = ["OBSERV", "BORRADOR"];
export const nemonicoEstadoDeshabilitar = ["OBSERV"];
